<template>
  <div>
    <health-widget icon="sales"
                   maxWidth="936px"
                   title="Продажи"
                   subtitle="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ornare sit."
                   class="health-widget"/>

    <collapse-card open :loading="loading" maxWidth="936px">
      <div slot="title">Основная информация</div>
      <main-information/>
    </collapse-card>

    <collapse-card open :loading="loading" maxWidth="936px">
      <div slot="title">Список покупок</div>
      <div slot="link">
        <el-date-picker
            size="small"
            v-model="date"
            type="daterange"
            format="dd.MM.yyyy"
            placeholder="Выберите дату"
            unlink-panels
            range-separator="-"
            start-placeholder="С"
            end-placeholder="По"
            :picker-options="pickerOptions"
            class="date-picker"
        />
      </div>
      <!--      <health-station :deviceData="healthStation" :editDeviceData="deviceModal"/>-->
    </collapse-card>


  </div>
</template>

<script>
import CollapseCard from "@/components/elements/BigCard.vue"
import HealthWidget from "@/components/elements/HealthWidget.vue"
import MainInformation from "@/components/sales/MainInformation.vue"

export default {
  name: "sales.list",
  data: function () {
    return {
      date: [ "2021-08-31T20:00:00.000Z", "2021-09-07T20:00:00.000Z" ],
      usersList: null,
      pagination: null,
      visibleDialogNewUser: false,
      loading: false,
      sort: {},
      search: {
        departmentId: 0,
        inspectionStatus: null,
        phone: null,
        id: null,
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Месяц ',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  components: {
    HealthWidget,
    CollapseCard,
    MainInformation
  },
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false;
    },

  },
  created() {
    this.loadList();
  },
  methods: {


    addClient() {
      this.visibleDialogNewUser = true
    },
    createdUser(user) {
      this.$router.push({name: "user.item", params: {id: user.id}})
    },
    loadList(page = 1, sort = {}) {
      this.loading = true

      let params = {
        params: {
          page,
          limit: 15,
          sortedBy: sort.order === 'ascending' ? 'asc' : sort.order === 'descending' ? 'desc' : null,
          orderBy: sort.prop ? sort.prop : null,
          search: this.search.phone ? this.search.phone : null,
        }
      }

      this.$api.user
          .list(params)
          .then((response) => {
            this.usersList = response.data.data;

            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
            })
          })
          .finally(() => {
            this.loading = false;
          })
    },
    openUser(visit) {
      this.$router.push({name: "user.item", params: {id: visit.id}});
    },

  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/zebra-table.scss";

.user-data {
  display: flex;
  justify-content: flex-start;
  align-content: center;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px;


  &__name {
    font-weight: 600;
    font-size: 15px;
    line-height: 16px;

    color: #111111;
  }

  &__phone {
    font-size: 15px;
    line-height: 16px;

    color: #111;
    margin-left: 10px;

  }

}

.panel {

  display: flex;
  align-items: center;
  justify-content: space-between;


  margin: 16px 0 32px 0;

  &__title {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #111;
    letter-spacing: -0.005em;


  }

  &__input {
    max-width: 260px;
  }

}

.date-picker {
  margin-left: 16px;
  width: 226px;
}

.visits {
  margin: 0;
  padding-bottom: 20px;

}

.time-point {

  display: flex;
  align-items: center;
  justify-content: flex-start;
  letter-spacing: 0.4px;

  &__date {
    font-size: 15px;
    line-height: 16px;
    color: #111111;

  }

  &__time {
    margin-left: 10px;

    font-size: 15px;
    line-height: 16px;
    color: #8E8E93;
  }
}

.zebra-table {
  margin-top: 32px;

  font-size: 15px;
  line-height: 16px;
  color: #676767;

  /deep/ .el-table__row {
    height: 60px;
  }
}

/deep/ .el-loading-mask {
  background-color: rgba(239, 239, 244, .87) !important;
}

.health-widget {
  margin-top: 24px;
}
</style>
